// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M7.83 13L12.73 17.9Q13.03 18.2 13.02 18.6T12.71 19.3Q12.41 19.58 12.01 19.59T11.31 19.3L4.71 12.7Q4.56 12.55 4.5 12.37T4.43 12 4.49 11.62 4.7 11.29L11.3 4.69Q11.58 4.41 11.99 4.41T12.7 4.69Q13 4.99 13 5.4T12.7 6.11L7.83 11H19Q19.42 11 19.71 11.29T20 12 19.71 12.71 19 13Z"/>';

/** Back (arrows). */
const icon: IconData = {
  id: "arrow-left",
  name: "Back",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M7.83 13L13.43 18.6 12 20 4 12 12 4 13.43 5.4 7.83 11H20V13Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M7.83 13L12.73 17.9Q13.03 18.2 13.02 18.6T12.71 19.3Q12.41 19.58 12.01 19.59T11.31 19.3L4.71 12.7Q4.56 12.55 4.5 12.37T4.43 12 4.49 11.62 4.7 11.29L11.3 4.69Q11.58 4.41 11.99 4.41T12.7 4.69Q13 4.99 13 5.4T12.7 6.11L7.83 11H19Q19.42 11 19.71 11.29T20 12 19.71 12.71 19 13Z"/></g><path d="M7.83 13L12.73 17.9Q13.03 18.2 13.02 18.6T12.71 19.3Q12.41 19.58 12.01 19.59T11.31 19.3L4.71 12.7Q4.56 12.55 4.5 12.37T4.43 12 4.49 11.62 4.7 11.29L11.3 4.69Q11.58 4.41 11.99 4.41T12.7 4.69Q13 4.99 13 5.4T12.7 6.11L7.83 11H19Q19.42 11 19.71 11.29T20 12 19.71 12.71 19 13Z"/>',
    },
  },
  animation: () => import("../animations/arrow-left.js"),
};

export default icon;
